import { css } from "lit";

export const styles = css`
  .containers {
    height: 100%;
  }

  .communities-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .main-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  .section-title {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-04) var(--sds-typography-family-title);
    margin: 0;
    color: var(--sds-color-text-default-primary);
    line-height: 20px;
    padding-bottom: var(--sds-size-space-800);
  }

  .loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 64px 24px;
    color: var(--sds-color-text-default-secondary);
  }

  .delete-confirmation-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 0;
  }

  .delete-confirmation-content p {
    margin: 0;
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
  }

  .confirmation-buttons {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-400);
    padding: var(--sds-size-space-300);
  }

  .communities-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--sds-size-space-400);
    margin-bottom: var(--sds-size-space-400);
  }

  .communities-header .section-title {
    padding-bottom: 0;
    white-space: nowrap;
  }

  .communities-filter {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-200);
    flex-wrap: wrap;
  }

  .communities-filter-mobile {
    display: none;
  }

  .member-badge {
    display: inline-flex;
    align-items: center;
    gap: var(--sds-size-space-200);
    padding: var(--sds-size-space-100) var(--sds-size-space-400);
    border-radius: var(--sds-size-radius-200);
    background: var(--sds-color-background-default-secondary);
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-01) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
  }

  @media (max-width: 900px) {
    .communities-filter {
      display: none;
    }

    .communities-filter-mobile {
      display: block;
      background: var(--sds-color-background-default-tertiary);
      color: var(--sds-color-text-default-primary);
      border: 1px solid var(--sds-color-border-default-default);
      border-radius: var(--sds-size-radius-200);
      padding: var(--sds-size-space-200) var(--sds-size-space-400);
      font: var(--sds-typography-weight-medium) var(--sds-typography-scale-02) var(--sds-typography-family-body);
      cursor: pointer;
    }
  }

  @media (max-width: 768px) {
    .section-title {
      font-size: var(--sds-typography-scale-03);
    }
  }
`;
